(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-information"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
const trigger=event.target.closest('[data-qc-dialog]');
if(trigger){document.getElementById(trigger.dataset.qcDialog)?.showModal();return}
if(event.target.matches('.qc-info-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-product-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('qc-auto-products')) {
customElements.define('qc-auto-products', class extends HTMLElement {
connectedCallback() {
this.timer=setInterval(()=>{
const list=this.querySelector('ul.slider');
if(!list||document.hidden||this.matches(':hover')||this.contains(document.activeElement)||this.paused||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
const box=this.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;
const max=list.scrollWidth-list.clientWidth;if(max<2)return;
const cards=list.querySelectorAll('.slider__slide');
const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:list.clientWidth;
list.scrollTo({left:list.scrollLeft>=max-4?0:Math.min(max,list.scrollLeft+step),behavior:'smooth'});
},3500);
this.toggle=document.createElement('button');this.toggle.type='button';this.toggle.className='slider-button';this.toggle.textContent='Ⅱ';
this.toggle.setAttribute('aria-label','Pause automatic scrolling');
this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();});
this.querySelector('.slider-buttons')?.append(this.toggle);
this.addEventListener('touchstart',()=>{this.paused=true;this.updateToggle();},{passive:true});
}
updateToggle(){this.toggle.textContent=this.paused?'▷':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?'Resume automatic scrolling':'Pause automatic scrolling');}
disconnectedCallback(){clearInterval(this.timer);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qiuola-about"]) return;
  try {
    
function enhanceQiuolaAbout(){document.querySelectorAll('[data-about-content]:not([data-enhanced])').forEach(root=>{root.dataset.enhanced='true';let card=document.createElement('section');card.className='qa-about-card';const cards=[card];Array.from(root.childNodes).forEach(node=>{if(node.nodeName==='HR'){card=document.createElement('section');card.className='qa-about-card';cards.push(card)}else{card.append(node)}});root.replaceChildren(...cards.filter(c=>c.textContent.trim()));root.querySelectorAll('.qa-about-card').forEach(c=>{const first=c.querySelector('p');if(first&&first.querySelector('strong')){const h=document.createElement('h2');h.textContent=first.textContent;first.replaceWith(h)}});root.querySelectorAll('p').forEach(p=>{if(p.textContent.includes('Follow us on Instagram')){p.replaceChildren();const a=document.createElement('a');a.href='https://www.instagram.com/qiuola.co/';a.textContent='Follow our official Instagram @qiuola.co';p.append(a)}})})}
enhanceQiuolaAbout();document.addEventListener('shopify:section:load',enhanceQiuolaAbout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qiuola-faq-page"]) return;
  try {
    
function qiuolaFaq(){document.querySelectorAll('.qf-page:not([data-ready])').forEach(root=>{const content=root.querySelector('.qf-content'),nav=root.querySelector('.qf-nav');const nodes=Array.from(content.children);if(!nodes.some(n=>n.querySelector('strong')?.textContent.includes('?')))return;root.dataset.ready='true';let group,answer;const groups=[];nodes.forEach(node=>{if(node.tagName==='HR')return;const strong=node.querySelector('strong');if(strong){const title=strong.textContent.trim();if(title==='FREQUENTLY ASKED QUESTIONS')return;if(!title.includes('?')){group=document.createElement('section');group.className='qf-group';group.id='faq-topic-'+groups.length;const h=document.createElement('h2');h.textContent=title.toLowerCase().replace(/(^|\s)\S/g,c=>c.toUpperCase());group.append(h);groups.push(group);const a=document.createElement('a');a.href='#'+group.id;a.textContent=h.textContent;nav.append(a);answer=null;return}if(group){const details=document.createElement('details');const summary=document.createElement('summary');summary.textContent=title;answer=document.createElement('div');answer.className='qf-answer';strong.remove();const br=node.querySelector('br');if(br)br.remove();answer.append(node);details.append(summary,answer);group.append(details);return}}if(answer&&node.textContent.trim())answer.append(node)});if(groups.length){content.replaceChildren(...groups);nav.hidden=false}})}
qiuolaFaq();document.addEventListener('shopify:section:load',qiuolaFaq);

  } catch(e) { console.error(e); }
})();
})();
